import React from 'react';
import ic403 from '../../asset/login/403.png';
import './index.less';
import { useStatistics } from '../../utils/statistics';
export function NoPermission(_ref) {
  var style = _ref.style,
    className = _ref.className,
    onClick = _ref.onClick,
    text = _ref.text,
    imgUrl = _ref.imgUrl,
    img = _ref.img,
    onImgClick = _ref.onImgClick;
  useStatistics('NoPermission');
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    onClick: onClick,
    className: "".concat(className, " login-403-wrap")
  }, img || /*#__PURE__*/React.createElement("img", {
    src: imgUrl || ic403,
    alt: "",
    onClick: onImgClick,
    className: "login-403-img"
  }), /*#__PURE__*/React.createElement("div", {
    className: "login-403-text fontBold"
  }, text || '账号无权限，请联系学校管理员'));
}